import { NgModule } from '@angular/core';
import {
  MatButtonModule,
  MatIconModule,
  MatTooltipModule
} from '@angular/material';
import { FcDateInputModule } from '@core/components/fc-input/base/fc-date-input/fc-date-input.module';
import { FcOutlinedInputModule } from '@core/components/fc-input/base/fc-outlined-input/fc-outlined-input.module';
import { FcTextAreaInputModule } from '@core/components/fc-input/base/fc-text-area-input/fc-text-area-input.module';
import { FcTimeInputModule } from '@core/components/fc-input/base/fc-time-input/fc-time-input.module';
import { FcMaintenanceTypesInputModule } from '@core/components/fc-input/search-many/fc-maintenance-types-input/fc-maintenance-types-input.module';
import { FcSegmentsInputModule } from '@core/components/fc-input/search-many/fc-segments-input/fc-segments-input.module';
import { FcAddressInputModule } from '@core/components/fc-input/search-one/fc-address-input/fc-address-input.module';
import { FcCompanyInputModule } from '@core/components/fc-input/search-one/fc-company-input/fc-company-input.module';
import { FcLocationInputModule } from '@core/components/fc-input/search-one/fc-location-input/fc-location-input.module';
import { FcMaintenanceTypeModule } from '@core/components/fc-input/search-one/fc-maintenance-type-input/fc-maintenance-type-input.module';
import { FcProblemInputModule } from '@core/components/fc-input/search-one/fc-problem-input/fc-problem-input.module';
import { FcSegmentModule } from '@core/components/fc-input/search-one/fc-segment-input/fc-segment-input.module';
import { FcDeadlineContractOutlinedSelectModule } from '@core/components/fc-select/search-one/fc-deadline-contract-outlined-select/fc-deadline-contract-outlined-select.module';
import { FuseSharedModule } from '@fuse/shared.module';
import { TranslateModule } from '@ngx-translate/core';
import { ScheduleSuggestionsModule } from 'app/main/maintenances/components/schedule-suggestions/schedule-suggestions.module';
import { DialogSchedulingSuggestionsComponent } from '../../../dialog-scheduling-suggestions/dialog-scheduling-suggestions.component';
import { TabGeneralComponent } from './tab-general.component';


@NgModule({
  entryComponents: [
    TabGeneralComponent,
    DialogSchedulingSuggestionsComponent
  ],
  declarations: [
    TabGeneralComponent,
    DialogSchedulingSuggestionsComponent
  ],
  imports: [
    TranslateModule,
    FuseSharedModule,
    MatIconModule,
    MatButtonModule,
    MatTooltipModule,
    FcDateInputModule,
    FcTimeInputModule,
    FcOutlinedInputModule,
    FcLocationInputModule,
    FcCompanyInputModule,
    FcProblemInputModule,
    FcMaintenanceTypeModule,
    FcSegmentModule,
    FcTextAreaInputModule,
    FcMaintenanceTypesInputModule,
    FcSegmentsInputModule,
    FcAddressInputModule,
    ScheduleSuggestionsModule,
    FcDeadlineContractOutlinedSelectModule
  ],
  exports: [
    TabGeneralComponent
  ]
})
export class TabGeneralModule { }
